import { render, staticRenderFns } from "./ScreenDesign2.vue?vue&type=template&id=0db1809b&scoped=true"
import script from "./ScreenDesign2.vue?vue&type=script&lang=js"
export * from "./ScreenDesign2.vue?vue&type=script&lang=js"
import style0 from "./ScreenDesign2.vue?vue&type=style&index=0&id=0db1809b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1809b",
  null
  
)

export default component.exports